"use client"

import Link from "next/link"
import { useQuery } from "@tanstack/react-query"
import { FaFacebookF, FaInstagram, FaXTwitter, FaYoutube } from "react-icons/fa6"
import { Mail, MapPin, Phone } from "lucide-react"

import { fetchJson } from "@/lib/client/fetch-json"

type CmsFooterPage = {
  id: string
  slug: string
  title: string
}

export default function Footer() {
  const footerPagesQuery = useQuery({
    queryKey: ["cms-pages", "footer"] as const,
    staleTime: 5 * 60 * 1000,
    queryFn: ({ signal }) =>
      fetchJson<CmsFooterPage[]>("/api/pages?placement=footer", {
        signal,
        fallbackMessage: "Не вдалося завантажити footer pages",
      }),
  })

  const footerPages = Array.isArray(footerPagesQuery.data) ? footerPagesQuery.data : []

  return (
    <footer className="border-t border-[var(--footer-border)] bg-[color:var(--footer-background)] text-[color:var(--footer-text)]">
      <div className="max-w-[1400px] mx-auto px-4 py-8 md:py-9">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-[1.2fr_1fr_1fr] md:gap-8">
          <div>
            <div className="mb-4 flex items-center gap-2">
              <Link href="/" className="text-xl font-bold text-[color:var(--link)] transition-colors hover:text-[color:var(--link-hover)]">
                ROZDRIB
              </Link>
            </div>
             <p className="text-sm mb-3 leading-relaxed">
              Ваш надійний партнер у світі електроніки. Продаємо тільки оригінальну техніку з офіційною гарантією.
            </p>
            <div className="flex gap-3">
              <a href="#" className="flex h-9 w-9 items-center justify-center rounded-lg bg-[var(--menu-item-hover)] text-[color:var(--footer-text)] transition-colors hover:bg-primary hover:text-on-emphasis"><FaFacebookF className="w-4 h-4" /></a>
              <a href="#" className="flex h-9 w-9 items-center justify-center rounded-lg bg-[var(--menu-item-hover)] text-[color:var(--footer-text)] transition-colors hover:bg-primary hover:text-on-emphasis"><FaInstagram className="w-4 h-4" /></a>
              <a href="#" className="flex h-9 w-9 items-center justify-center rounded-lg bg-[var(--menu-item-hover)] text-[color:var(--footer-text)] transition-colors hover:bg-primary hover:text-on-emphasis"><FaXTwitter className="w-4 h-4" /></a>
              <a href="#" className="flex h-9 w-9 items-center justify-center rounded-lg bg-[var(--menu-item-hover)] text-[color:var(--footer-text)] transition-colors hover:bg-primary hover:text-on-emphasis"><FaYoutube className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h3 className="mb-3 font-semibold text-[color:var(--footer-text)]">Інформація</h3>
            <ul className="grid gap-x-4 gap-y-1.5 text-sm sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2">
              {footerPages.map((page) => (
                <li key={page.id}><Link href={`/${page.slug}`} className="transition-colors hover:text-[color:var(--link-hover)] text-[color:var(--link)]">{page.title}</Link></li>
              ))}
              {!footerPagesQuery.isLoading && footerPages.length === 0 ? <li className="text-secondary">Немає сторінок для footer</li> : null}
            </ul>
          </div>

          <div>
            <h3 className="mb-3 font-semibold text-[color:var(--footer-text)]">Контакти</h3>
            <div className="space-y-2 text-sm">
              <div className="flex items-start gap-3"><Phone className="mt-0.5 h-4 w-4 text-[color:var(--link)]" /><span>телефон</span></div>
              <div className="flex items-start gap-3"><Mail className="mt-0.5 h-4 w-4 text-[color:var(--link)]" /><span>rozdrib.store@gmail.com</span></div>
              <div className="flex items-start gap-3"><MapPin className="mt-0.5 h-4 w-4 text-[color:var(--link)]" /><span>Україна, Чернівці</span></div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}
